import { FC } from 'react';
import { Card } from '@features/ui';
import { cn, formatCurrency } from '@lib/utils.ts';
import { PayoutRes } from '@src/types';

interface PayoutRequestInformationProps {
  className?: string;
  data: PayoutRes | null;
}
export const PayoutRequestInformation: FC<PayoutRequestInformationProps> = ({
  className,
  data,
}) => {
  return (
    <Card className={cn('flex flex-row gap-x-6.5', className)}>
      <div className={'flex gap-x-2 items-center'}>
        <p className={'text-sm font-bold'}>Awaiting Approval:</p>
        <p className={'text-xs'}>
          {data?.approved_total && data.approved_total !== '0'
            ? `$ ${formatCurrency(Number(data.approved_total), 2)}`
            : '-'}
        </p>
      </div>
      <div className={'flex gap-x-2 items-center'}>
        <p className={'text-sm font-bold'}>Awaiting Payment:</p>
        <p className={'text-xs'}>
          {data?.paid_total && data.paid_total !== '0'
            ? `$ ${formatCurrency(Number(data.paid_total), 2)}`
            : '-'}
        </p>
      </div>
      <div className={'flex gap-x-2 items-center'}>
        <p className={'text-sm font-bold'}>Payment Processing:</p>
        <p className={'text-xs'}>
          {data?.pending_total && data.pending_total !== '0'
            ? `$ ${formatCurrency(Number(data.pending_total), 2)}`
            : '-'}
        </p>
      </div>
      <div className={'flex gap-x-2 items-center text-[#4DA2FF]'}>
        <p className={'text-sm font-bold'}>Total</p>
        <p className={'text-xs'}>
          {data?.total && data.total !== '0'
            ? `$ ${formatCurrency(Number(data.total), 2)}`
            : '-'}
        </p>
      </div>
    </Card>
  );
};
